var map = {
	"./2playsamonth/BannerLogo.png": 54944,
	"./2playsamonth/HeroCoders.png": 71773,
	"./ActivityBanner": 83886,
	"./ActivityBanner.jsx": 83886,
	"./activitiesConfig": 37606,
	"./activitiesConfig.js": 37606,
	"./activityBanner.css": 31909,
	"./banner.png": 47094,
	"./hackathon/Logo.png": 63915,
	"./hackathon/Logo.svg": 96379,
	"./hackathon/img-hero-coders.png": 98085,
	"common/activities/2playsamonth/BannerLogo.png": 54944,
	"common/activities/2playsamonth/HeroCoders.png": 71773,
	"common/activities/ActivityBanner": 83886,
	"common/activities/ActivityBanner.jsx": 83886,
	"common/activities/activitiesConfig": 37606,
	"common/activities/activitiesConfig.js": 37606,
	"common/activities/activityBanner.css": 31909,
	"common/activities/banner.png": 47094,
	"common/activities/hackathon/Logo.png": 63915,
	"common/activities/hackathon/Logo.svg": 96379,
	"common/activities/hackathon/img-hero-coders.png": 98085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53827;